var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBoosterRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.25,
    fill: "#C8102E",
    stroke: "#C8102E",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6814 18.2002H13.8762C16.341 18.2002 17.9634 17.2018 17.9634 15.205V15.1738C17.9634 13.7074 17.1834 12.9742 15.9198 12.4906C16.6998 12.0538 17.355 11.3674 17.355 10.135V10.1038C17.355 9.35495 17.1054 8.74655 16.6062 8.24735C15.9822 7.62335 14.9994 7.28015 13.7514 7.28015H8.6814V18.2002ZM11.0214 11.695V9.38615H13.3926C14.4066 9.38615 14.9682 9.79175 14.9682 10.5094V10.5406C14.9682 11.3518 14.2974 11.695 13.2366 11.695H11.0214ZM11.0214 16.0942V13.6918H13.7982C15.0306 13.6918 15.5766 14.1442 15.5766 14.8774V14.9086C15.5766 15.7198 14.937 16.0942 13.8762 16.0942H11.0214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoosterRed);
export default __webpack_public_path__ + "static/media/icon-booster-red.24e457e338a019c61cfdd7e820be8174.svg";
export { ForwardRef as ReactComponent };